import {
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonItem,
} from '@ionic/react'
import { caretDown, caretUp } from 'ionicons/icons'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './CustomInput.component.css'
interface CustomInputProps {
  type?: string
  setType?: (type: string) => void
  cancel: () => void
  save: () => void
  label?: string
  heading: string
  firstSegmentValidation?: () => boolean
  saveButtonValidation?: (type: string | undefined) => boolean
}

const CustomInput: React.FC<CustomInputProps> = ({
  type,
  setType,
  save,
  cancel,
  label,
  heading,
  firstSegmentValidation,
  saveButtonValidation,
}) => {
  const { t } = useTranslation()
  const [showAccodionContent, setShowAccodionContent] = useState(false)
  return (
    <>
      <IonItem lines='none' onClick={() => setShowAccodionContent(!showAccodionContent)}>
        <IonLabel color='primary'>{heading}</IonLabel>
        <IonIcon slot='end' size='small' color='medium' icon={showAccodionContent ? caretUp : caretDown} />
      </IonItem>
      <div
        className={showAccodionContent ? 'm-left accordion-content-show' : 'm-left accordion-content-hide'}
        slot='content'>
        <div className='headingCheck'>
          <IonLabel id='type-label'>{label}</IonLabel>
        </div>
        {type && (
          <IonSegment
            color='dark'
            className='segment-bottom-padding ionSegmentWidth'
            value={type}
            onIonChange={(e) => {
              e.detail.value && setType && setType(e.detail.value)
            }}>
            <IonSegmentButton
              data-testid='MedicationSegment'
              value={'medication'}
              disabled={firstSegmentValidation ? firstSegmentValidation() : false}>
              <IonLabel>{t('patientAllergies.Medication')}</IonLabel>
            </IonSegmentButton>

            <IonSegmentButton data-testid='FoodSegment' value={'food'}>
              <IonLabel>{t('patientAllergies.Food')}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        )}
        <IonToolbar className='toolBar'>
          <IonButtons>
            <IonButton
              data-testid='CustomInputCancel'
              className='btn btn-secondary mr-8'
              expand='block'
              onClick={() => cancel()}>
              {t('common.buttons.Cancel')}
            </IonButton>
            <IonButton
              data-testid='CustomInputCancelAdd'
              className='btn btn-primary'
              expand='block'
              disabled={saveButtonValidation ? saveButtonValidation(type) : false}
              onClick={() => save()}>
              {t('common.buttons.Add')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </div>
    </>
  )
}

export default CustomInput
